const API_BASE_URL = 'https://talentra-585s.onrender.com/api';

export default API_BASE_URL;